import CONSTANTS from '../lib/constants';
import { logError } from '../services/sentryService';

/* global locale, shopApplicationName, adbAccEvent, SendAdobeData, SendABTestData, _satellite */
let UTILS = {};

UTILS.isAndroid = function () {
  let userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('android') > -1;
};

UTILS.isInternetExplorer = function () {
  let userAgent = navigator.userAgent;
  return /MSIE|Trident/.test(userAgent);
};

UTILS.isSafari = () =>
  /Safari/.test(window.navigator.userAgent) &&
  /Apple Computer/.test(window.navigator.vendor);

UTILS.maxLengthValidator = function (inputField, maxLength) {
  if (inputField.length > 0) {
    inputField.val().trim();
    inputField.keyup(function () {
      if (inputField.val().length > maxLength) {
        inputField.val(inputField.val().substr(0, maxLength));
      }
    });
  }
};

UTILS.adobeTrackingCall = function (
  form,
  input,
  action,
  addedFromReco = false
) {
  let variantId = form.find('input[name="articleVariantId"]').val();
  let price = form.find('input[name="articlePrice"]').val();
  let abdFlag = form.find('input[name="voucherApplied"]').val();
  let quantity;
  if (typeof SendAdobeData === 'function') {
    try {
      if (form[0].classList.contains('articleQtyFormReco')) {
        quantity = 1;
      } else {
        quantity = Math.abs(input.val() - input.attr('data-initial-value'));
      }
      if (action === 'add') {
        if (addedFromReco) {
          SendAdobeData(
            'newAddBasket',
            variantId,
            price,
            quantity,
            `abd=${abdFlag}`,
            true,
            'addedFromReco'
          );
        } else {
          SendAdobeData(
            'newAddBasket',
            variantId,
            price,
            quantity,
            `abd=${abdFlag}`,
            true
          );
        }
      } else if (action === 'remove') {
        SendAdobeData(
          'newRemoveBasket',
          variantId,
          price,
          quantity,
          `abd=${abdFlag}`,
          true
        );
      }
      const submitForm = () => {
        setTimeout(() => {
          form.trigger('submit', ['manualSubmit']);
        }, 500);
      };
      window.addEventListener('cart.action', function () {
        clearTimeout(submitForm);
      });
      submitForm();
    } catch (err) {
      console.log(
        'Error with SendAdobeData\n' +
          'Action:' +
          action +
          '\n' +
          'Id:' +
          variantId +
          '\n',
        err
      );
    }
  }
};

export const addEnterBehaviorForFormElement = (elementSelector) => {
  $(elementSelector).map((index, elem) => {
    elem.onkeydown = (e) => {
      if (e.key === 'Enter') {
        e.target.previousElementSibling.click();
      }
    };
  });
};

export async function fetchRequest(url, data, headers, method) {
  let options = {
    headers: headers,
    method: method,
    credentials: 'same-origin',
  };

  if (method === 'post') options.body = JSON.stringify(data);

  const res = await fetch(url, options);

  if (!res.ok) {
    throw res; // Throw error object to be handled by caller
  } else if (res.status === 204) {
    throw new Error(CONSTANTS.ERROR_MESSAGES.EMPTY_BODY);
  }

  return await res.json();
}

export const getInternalRequestHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  if (shopApplicationName) headers['X-Caller'] = shopApplicationName;
  return headers;
};

// If shop locale is not available we use the browser's locale
export function getLocale() {
  if (locale) return locale.replace('_', '-');
  else {
    return navigator.language;
  }
}

String.prototype.capitalize = function () {
  let words = this.split(' ');
  words = words.map(
    (word) =>
      word.toLowerCase().charAt(0).toUpperCase() + word.toLowerCase().slice(1)
  );
  return words.join(' ');
};

export function showPageLoader() {
  $('body').addClass('loading');
}

export function hidePageLoader() {
  $('body').removeClass('loading');
}

export const collectBrowserInformation = () => {
  const screenWidth = window?.screen?.width || window?.innerWidth || 0;
  const screenHeight = window?.screen?.height || window?.innerHeight || 0;

  const colorDepth = window?.screen?.colorDepth || 1;
  const userAgent = navigator?.userAgent || 'None';
  const language = navigator?.language || navigator?.browserLanguage || 'en-GB';

  const javaEnabled =
    typeof navigator?.javaEnabled === 'function'
      ? navigator.javaEnabled()
      : false;

  const timeZoneOffset = new Date().getTimezoneOffset() || '0';

  return {
    screenWidth,
    screenHeight,
    colorDepth,
    userAgent,
    timeZoneOffset,
    language,
    javaEnabled,
  };
};

export const createIframe = (container, name, width = '0', height = '0') => {
  const configObject = {};
  configObject.container = void 0;

  if (!name || name.length === 0) {
    throw new Error('Name parameter missing for iframe');
  }
  // Resolve holding element for generated iframe else default to body
  if (container instanceof HTMLElement) {
    configObject.container = container;
  } else {
    configObject.container = document.body;
  }

  const iframe = document.createElement('iframe');

  iframe.classList.add(name + 'Class');
  iframe.width = width;
  iframe.height = height;
  iframe.name = name;
  iframe.setAttribute('border', '0');

  configObject.container.appendChild(iframe);
  const noIframeElContent = document.createTextNode(
    '<p>Your browser does not support iframes.</p>'
  );
  iframe.appendChild(noIframeElContent);

  return iframe;
};

export const encodeBase64URL = (dataStr) => {
  let base64 = window.btoa(dataStr);
  let base64url = base64.split('=')[0]; // Remove any trailing '='s

  base64url = base64url.replace(/\+/g, '-'); // 62nd char of encoding
  base64url = base64url.replace(/\//g, '_'); // 63rd char of encoding

  return base64url;
};

export const validateField = (
  value,
  minSize,
  maxSize,
  pattern,
  required,
  container
) => {
  let isValid = false;
  let fieldError;
  if (required && value.length === 0) {
    fieldError = ERROR_TYPES.REQUIRED;
    showErrorMessageForField($('#js-errorRequired'), container);
  } else if (value.length < minSize || value.length > maxSize) {
    fieldError = ERROR_TYPES.SIZE;
    showErrorMessageForField($('#js-errorLength'), container);
  } else if (!pattern.test(value)) {
    fieldError = ERROR_TYPES.FORBIDDEN_CHAR;
    showErrorMessageForField($('#js-errorPattern'), container);
  } else {
    isValid = true;
  }
  return { errorType: fieldError, isValid };
};

export const validatePhoneNumber = (
  phoneInstance,
  phoneNumber,
  required,
  container
) => {
  let isPhoneValid = phoneInstance.isValidNumber();
  const phoneRegex = /^[ 0-9+-]*$/;
  let isValid = false;
  let fieldError;
  let isEmpty = phoneNumber.length === 0;

  if (isEmpty && required) {
    fieldError = ERROR_TYPES.REQUIRED;
    showErrorMessageForField($('#js-errorRequired'), container);
    return { errorType: fieldError, isValid: false };
  }

  if (!phoneRegex.test(phoneNumber)) {
    fieldError = ERROR_TYPES.FORBIDDEN_CHAR;
    showErrorMessageForField($('#js-errorPattern'), container);
    return { errorType: fieldError, isValid: false };
  }

  const errorCode = !isEmpty ? phoneInstance.getValidationError() : 0;

  if (!isPhoneValid) {
    switch (errorCode) {
      case 0:
        isValid = true;
        break;
      case 1:
        fieldError = ERROR_TYPES.INVALID_COUNTRY_CODE;
        showErrorMessageForField($('#js-errorInvalidCountryCode'), container);
        break;
      case 2:
        fieldError = ERROR_TYPES.SIZE;
        showErrorMessageForField($('#js-errorTooShort'), container);
        break;
      case 3:
        fieldError = ERROR_TYPES.SIZE;
        showErrorMessageForField($('#js-errorTooLong'), container);
        break;
      case 4:
        fieldError = ERROR_TYPES.NOT_NUMBER;
        showErrorMessageForField($('#js-errorNotNumber'), container);
        break;
      case 5:
        fieldError = ERROR_TYPES.SIZE;
        showErrorMessageForField($('#js-errorGeneralPhoneLength'), container);
        break;
      case -99:
        fieldError = ERROR_TYPES.NOT_NUMBER;
        showErrorMessageForField($('#js-errorPattern'), container);
        break;
      default:
        isValid = true;
        break;
    }
  } else {
    cleanErrors(container);
  }

  return { errorType: fieldError, isValid: isValid || isPhoneValid };
};

export const showErrorMessageForField = (message, container) => {
  cleanErrors(container);
  const msgElem = message.clone();
  msgElem.appendTo(container);
  msgElem.removeClass('hidden');
  container.addClass('ERROR');
};

export const cleanErrors = (container) => {
  container.removeClass('ERROR');
  container.find('[class*=error]').remove();
};

export const getCartObjectJson = () => {
  const cartDataText = document.getElementById('cartDataObject').innerText;
  return cartDataText !== '' ? JSON.parse(cartDataText) : null;
};

export const getDeliveryObjectJson = () => {
  const element = document.getElementById('deliveryDataObject');
  if (!element) return null;

  const deliveryDataText = element.innerText?.trim();
  if (!deliveryDataText) return null;

  try {
    return JSON.parse(deliveryDataText);
  } catch (error) {
    logError(`Failed to parse delivery data JSON: ${error.message}`);
    return null;
  }
};

export const getCheckoutStateCartDataObject = () => {
  const checkoutStateCartDataObject = document.getElementById(
    'checkoutStateCartDataObject'
  ).innerText;
  return checkoutStateCartDataObject !== ''
    ? JSON.parse(checkoutStateCartDataObject)
    : null;
};

export const parseStringJSON = (stringJSON) => {
  if (stringJSON) {
    try {
      return JSON.parse(stringJSON);
    } catch {
      return null;
    }
  }

  return null;
};

export function showUntilLimit(limit, $items) {
  let counter = 1;
  $items.each(function () {
    if ($(this).hasClass('hidden')) {
      $(this).removeClass('hidden');
    }
    if (counter >= limit) {
      $(this).addClass('hidden');
    }
    counter++;
  });
}

export const isMobile = () =>
  navigator.userAgent.match(
    /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i
  );

export const getStyleguideClasses = (classes) =>
  classes.map((cl) => `${CONSTANTS.STYLEGUIDE_VERSION}-${cl}`);

export const getUiLibraryClasses = (classes) =>
  classes.map((cl) => `${CONSTANTS.UI_LIBRARY_PREFIX}-${cl}`);

export const trackEvents = (eventName, eventData) => {
  if (
    typeof adbAccEvent !== 'undefined' &&
    typeof adbAccEvent.track === 'function'
  )
    adbAccEvent.track(eventName, eventData);
};

/**
 * Sends an event to Adobe Analytics. Accepts one or more arguments
 * @param {string} eventName
 * @param  {...string} otherEventData
 */
export const sendAdobeData = (eventName, ...otherEventData) => {
  if (
    typeof SendAdobeData !== 'undefined' &&
    typeof SendAdobeData === 'function'
  ) {
    SendAdobeData(eventName, ...otherEventData);
  }
};

export const sendABTestData = (toolShortName, activityName, experienceName) => {
  if (
    typeof SendABTestData !== 'undefined' &&
    typeof SendABTestData === 'function'
  ) {
    SendABTestData(toolShortName, activityName, experienceName);
  }
};

export const ERROR_TYPES = {
  REQUIRED: 'required',
  SIZE: 'size',
  NOT_NUMBER: 'notANumber',
  FORBIDDEN_CHAR: 'forbiddenCharacters',
  INVALID_COUNTRY_CODE: 'invalidCountryCode',
};

export const dsMapToDeliveryServiceDto = (pudoInfo, customerEmail) => {
  return {
    pudoCollectorFirstName: pudoInfo.collector.firstName,
    pudoCollectorLastName: pudoInfo.collector.lastName,
    pudoCollectorPhoneNumber: pudoInfo.collector.phoneNumber,
    customerCarrierId: pudoInfo.collector.customerCarrierId,
    contactEmail: customerEmail,
    pointId: pudoInfo.pudoPoint.pudoPointId,
    name: pudoInfo.pudoPoint.location.name,
    nameDisplay: pudoInfo.pudoPoint.location.nameDisplay,
    addressDisplay: pudoInfo.pudoPoint.location.addressDisplay,
    address1: pudoInfo.pudoPoint.location.addressLine1,
    address2: pudoInfo.pudoPoint.location.addressLine2,
    countryCode: pudoInfo.pudoPoint.location.countryCode,
    postCode: pudoInfo.pudoPoint.location.postCode,
    city: pudoInfo.pudoPoint.location.city,
    latitude: pudoInfo.pudoPoint.location.latitude,
    longitude: pudoInfo.pudoPoint.location.longitude,
    pudoProvider: pudoInfo.pudoPoint.pudoProvider,
  };
};

export const dsMapToPudoInfo = (pudoInfo) => {
  return {
    collector: {
      firstName: pudoInfo.pudoCollectorFirstName,
      lastName: pudoInfo.pudoCollectorLastName,
      phoneNumber: pudoInfo.pudoCollectorPhoneNumber,
      customerCarrierId: pudoInfo.customerCarrierId,
    },
    pudoPoint: {
      pudoPointId: pudoInfo.pointId,
      pudoProvider: pudoInfo.pudoProvider,
      location: {
        name: pudoInfo.name,
        nameDisplay: pudoInfo.nameDisplay,
        addressDisplay: pudoInfo.addressDisplay,
        addressLine1: pudoInfo.address1,
        addressLine2: pudoInfo.address2,
        countryCode: pudoInfo.countryCode,
        postCode: pudoInfo.postCode,
        city: pudoInfo.city,
        latitude: pudoInfo.latitude,
        longitude: pudoInfo.longitude,
      },
    },
  };
};

export const isMyAccount = window.location.href.includes('account');

export const applyClassBasedOnResolution = (
  $element,
  screenWidthValue,
  classesToRemove,
  classesToAdd
) => {
  if ($element.length === 0) return;

  const screenWidth = $(window).width();

  if (screenWidth <= screenWidthValue) {
    $element
      .removeClass([...getStyleguideClasses(classesToRemove)])
      .addClass([...getStyleguideClasses(classesToAdd)]);
  } else {
    $element
      .removeClass([...getStyleguideClasses(classesToAdd)])
      .addClass([...getStyleguideClasses(classesToRemove)]);
  }
};

export const getLibraryPrefix = (elementObj) => {
  return elementObj.attr('class').includes('z-modal')
    ? CONSTANTS.UI_LIBRARY_PREFIX
    : CONSTANTS.STYLEGUIDE_VERSION;
};

export const isAdobeSatelliteTrackingReady = () => {
  return (
    typeof _satellite !== 'undefined' && typeof _satellite.track === 'function'
  );
};

export const focusAccessibleAlert = () => {
  setTimeout(() => {
    $('.accessible-alert').trigger('focus');
  }, 500);
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const { PLATFORM_TYPE } = CONSTANTS;

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return PLATFORM_TYPE.IOS;
  }

  if (/android/i.test(userAgent)) {
    return PLATFORM_TYPE.ANDROID;
  }

  return PLATFORM_TYPE.WEB;
};

export default UTILS;
